import React, { useState } from "react";
import BoardPic from "../../Components/Images/board.png";
import "./Board.css";
import Connectors from "../Connectors/Connectors";
import Devices from "../Devices/Devices";
import AvailableDevices from "../Devices/AvailableDevices";
import DeviceCatalog from "../DeviceCatalog/DeviceCatalog";
import Conn_Devices from "../ConnDevices/ConnDevices";
import { StickyContainer, Sticky } from "react-sticky";

import device_connector_mapping from "./DeviceConnectorMapping.js";
import devices_list from "./DevicesList.js";
// import { isDOMComponent } from "react-dom/test-utils";
const Board = () => {
  const connectors_list = [
    {
      id: 1,
      name: "Conn A",
      name_short: "A",
      type: "A",
      connected_devices_id: [],
    },
    {
      id: 2,
      name: "Conn B",
      name_short: "B",
      type: "B",
      connected_devices_id: [],
    },
    {
      id: 3,
      name: "Conn C",
      name_short: "C",
      type: "C",
      connected_devices_id: [],
    },
    {
      id: 4,
      name: "Conn D",
      name_short: "D",
      type: "D",
      connected_devices_id: [],
    },
    {
      id: 5,
      name: "Conn E",
      name_short: "E",
      type: "E",
      connected_devices_id: [],
    },
    {
      id: 6,
      name: "Conn F",
      name_short: "F",
      type: "F",
      connected_devices_id: [],
    },
    {
      id: 7,
      name: "Conn G",
      name_short: "G",
      type: "G",
      connected_devices_id: [],
    },
  ];

  const adapters_list = [
    { id: 1, name: "A", img_name: "adapter_a.png" },
    { id: 2, name: "C", img_name: "adapter_c.png" },
    { id: 3, name: "DE_1", img_name: "adapter_de_1.png" },
    { id: 4, name: "DE_2", img_name: "adapter_de_2.png" },
  ];

  const connectedDevices_example = [{ connectori_id: 1, devices_id: [1, 3] }];

  const [selectedConnector, setSelectedConnector] = useState(
    connectors_list[0]
  );
  const [connectorsList, setconnectorsList] = useState(connectors_list);

  const updateSelectedConnector = (connector) => {
    setSelectedConnector(connector);
    console.log("Selected Connector: ", connector);
  };

  const updateConnectorsListWithDevices = (
    devices_to_add,
    connector_to_update
  ) => {
    // devices_to_add is an array of device ids
    // connector_to_update is the connector object
    console.log("update device called: ", devices_to_add);
    console.log("connector called: ", connector_to_update);
    const updated_connectors_list = connectorsList.map((connector) => {
      if (connector.id === connector_to_update.id) {
        return {
          ...connector,
          connected_devices_id: devices_to_add,
        };
      }
      return connector;
    });
    setconnectorsList(updated_connectors_list);
    console.log("updated connectors list: ", updated_connectors_list);
  };

  return (
    <div className="container-fluid project-section">
      <div className="d-md-flex">
        <div className="board-drawing align-self-top ">
          <div className=" justify-content-center row px-0">
            <div className="col-8 col-sm-8 col-md-10 px-0">
              <div className="row top-connectors">
                <div className="col-3 connector px-1 d-flex align-items-end"></div>
                <div className="col-2 connector px-1 d-flex align-items-end">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[1]}
                    orientation="top"
                  />
                </div>

                <div className="col-2 connector px-1 d-flex align-items-end">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[2]}
                    orientation="top"
                  />
                </div>
                <div className="col-2  connector px-1 d-flex align-items-end">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[3]}
                    orientation="top"
                  />
                </div>
                <div className="col-2 connector px-1 d-flex align-items-end">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[4]}
                    orientation="top"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 board-section ">
                  <img src={BoardPic} alt="Board" />
                </div>
              </div>
              <div className="row bottom-connectors">
                <div className="col-4 connector px-1 d-flex align-items-start"></div>
                <div className="col-2 connector px-1 d-flex align-items-start">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[6]}
                    orientation="bottom"
                  />
                </div>
                <div className="col-2 connector px-1 d-flex align-items-start">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[5]}
                    orientation="bottom"
                  />
                </div>
                <div className="col-1 connector px-1 d-flex align-items-start"></div>
                <div className="col-2 connector px-1 d-flex align-items-start">
                  <Conn_Devices
                    connectorsList={connectorsList}
                    devices_list={devices_list}
                    adapters_list={adapters_list}
                    connector={connectors_list[0]}
                    orientation="bottom"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="board-connection-details col-12 col-md-7 border-start">
          <div className="sticky-box">
            <div>
              <Connectors
                connectors_list={connectors_list}
                updateSelectedConnector={updateSelectedConnector}
                selectedConnector={selectedConnector}
              />
            </div>
          </div>

          {/* <div className="container-fluid devices-section mt-2"> */}
          <Devices
            devices_list={devices_list}
            device_connector_mapping={device_connector_mapping}
            selectedConnector={selectedConnector}
            connectorsList={connectorsList}
            updateConnectorsListWithDevices={updateConnectorsListWithDevices}
            adapters_list={adapters_list}
          />
          {/* </div> */}
          {/* <div className="container-fliuid mt-2"> */}
          <AvailableDevices
            devices_list={devices_list}
            device_connector_mapping={device_connector_mapping}
            selectedConnector={selectedConnector}
            connectorsList={connectorsList}
            updateConnectorsListWithDevices={updateConnectorsListWithDevices}
            adapters_list={adapters_list}
          />

          {/* </div> */}
        </div>
      </div>
      {/* <DeviceCatalog devices_list={devices_list} /> */}
    </div>
  );
};

export default Board;
